// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DropdownController from "../../components/dropdown/component_controller.js";
application.register("dropdown", DropdownController);

import BirdListController from "./bird_list_controller.js";
application.register("bird-list", BirdListController);

import ViewMoreController from "./view_more_controller.js";
application.register("view-more", ViewMoreController);

import DismissController from "./dismiss_controller.js";
application.register("dismiss", DismissController);

import ModalController from "./../../components/modal/compontent_controller.js";
application.register("modal", ModalController);

import ColorPickerController from "./../../components/color_picker/component_controller.js";
application.register("color-picker", ColorPickerController);

import ComboboxController from "../../components/form/combobox_controller.js";
application.register("combobox", ComboboxController);


import CommentsController from "./comments_controller.js";
application.register("comments", CommentsController);

import ToggleController from "../../components/form/toggle_controller.js";
application.register("toggle", ToggleController);

import NotificationController from "./../../components/notification_component_controller.js";
application.register("notification", NotificationController);

import RadioGroupController from "./radio_group_controller";
application.register("radio-group", RadioGroupController);

import JoinClubController from "./join_club_controller.js";
application.register("join-club", JoinClubController);

import NavbarController from "./navbar_controller.js";
application.register("navbar", NavbarController);

import FormController from "./form_controller.js";
application.register("form", FormController);

import SelectController from "./select_controller.js";
application.register("select", SelectController);

import SlideoverController from "./slideover_controller.js";
application.register("slideover", SlideoverController);

import LocationSelectController from "./location_select_controller.js";
application.register("location-select", LocationSelectController);


import TabsController from "./tabs_controller.js";
application.register("tabs", TabsController);

import SliderController from "./slider_controller.js";
application.register("slider", SliderController);

import PhotoUploadController from "./../../components/photo_upload/component_controller.js";
application.register("photo-upload", PhotoUploadController);

import RecordFiltersController from "./record_filters_controller.js";
application.register("record-filters", RecordFiltersController);

import SettingsController from "./settings_controller";
application.register("settings", SettingsController);

import PageUrlController from "./page_url_controller";
application.register("page-url", PageUrlController);

import NewsSearchController from "./news_search_controller";
application.register("news-search", NewsSearchController);

import PdfModalController from "./pdf_modal_controller";
application.register("pdf-modal", PdfModalController);

import EventFormController from "./event_form_controller";
application.register("event-form", EventFormController);

import LocationSpeciesController from "./location_species_controller";
application.register("location-species", LocationSpeciesController);

import BadgeDesignPreviewController from "./badge_design_preview_controller";
application.register("badge-design-preview", BadgeDesignPreviewController);

import ReplyFormController from "./reply_form_controller";
application.register("reply-form", ReplyFormController);

import TiltController from "./tilt_controller";
application.register("tilt", TiltController);

